import styled from "styled-components";
import { COMPONENTS, SPACING } from "../../constants/design/spacing";
import {
  BACKGROUND_COLORS,
  TEXT_COLORS,
  BORDER_COLORS,
} from "../../constants/design/colors";
import { FONT_CSS } from "../../constants/design/fontSize";
import { FONT_WEIGHT } from "../../constants/design/fontWeight";

export const LiveTradesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100% - ${COMPONENTS.header.main}px);
  padding: ${SPACING.four}px;
  box-sizing: border-box;
  gap: ${SPACING.three}px;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${SPACING.two}px;
`;

export const PageTitle = styled.h2`
  ${FONT_CSS.header.five}
  color: ${TEXT_COLORS.one};
  margin: 0;
`;

export const LastUpdatedText = styled.span`
  ${FONT_CSS.body.five}
  color: ${TEXT_COLORS.two};
`;

export const FiltersWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${SPACING.four}px;
  padding: ${SPACING.three}px ${SPACING.four}px;
  border-radius: 12px;
  background: ${BACKGROUND_COLORS.component};
  border: 1px solid ${BORDER_COLORS.two};
`;

export const FilterGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.two}px;
  color: ${TEXT_COLORS.one};

  span {
    ${FONT_CSS.body.five}
    font-weight: ${FONT_WEIGHT.medium};
  }
`;

export const FilterInput = styled.input`
  ${FONT_CSS.body.five}
  border: 1px solid ${BORDER_COLORS.two};
  border-radius: 8px;
  padding: 6px ${SPACING.two}px;
  background: ${BACKGROUND_COLORS.component};
  color: ${TEXT_COLORS.one};
  min-width: 160px;

  ::placeholder {
    color: ${TEXT_COLORS.three};
  }
`;

export const WarningText = styled.div`
  ${FONT_CSS.body.five}
  color: ${TEXT_COLORS.two};
  padding: ${SPACING.two}px ${SPACING.three}px;
  border-radius: 8px;
  background: ${BACKGROUND_COLORS.fourteen};
  border: 1px solid ${BORDER_COLORS.two};
`;

export const TableContainer = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: ${SPACING.two}px;
`;
